export function buildQuery(params: Record<string, string | number | undefined>): string {
    const entries = Object.entries(params).filter(
        ([, value]) => value !== undefined && value !== ''
    );

    if (entries.length === 0) {
        return '';
    }

    return `?${entries.map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`).join('&')}`;
}
